<template>
  <div>
    <h2>General search</h2>
    <v-card>
      <v-card-text>
        <v-progress-circular indeterminate color="info" v-if="!general" />
        <template v-if="general && general.warning">
          <div v-for="(warning, windex) in general.warning" :key="windex">
            {{ `${warning.info} - ${warning.message}` }}
          </div>
        </template>
        <template v-if="general && general.generalResultSize > 0">
          <div
            style="
              float: right;
              text-align: right;
              font-size: 1.5em;
              font-weight: bold;
            "
          >
            {{ general.generalResultSize }} result(s)
          </div>
          <ol>
            <li
              style="margin-bottom: 5px"
              v-for="(generalResult, grindex) in general.generalResult"
              :key="grindex"
            >
              <div>
                <Entity :entity="generalResult.entity" />
                <span style="color: green"
                  >&#160;{{ generalResult.entityType.name }}</span
                >
              </div>
              <div>
                <span
                  v-for="(fragment, index) in generalResult.fragment"
                  :key="index"
                  :class="fragment.className"
                  >{{ fragment.body }}</span
                >
                <span style="color: gray"
                  >score:{{ generalResult.score }} hits:{{
                    generalResult.hit.length
                  }}</span
                >
              </div>
            </li>
          </ol>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

  <script>
import SEARCH_GENERAL from "@/graphql/search/SearchGeneral";
import Entity from "@/components/link/Entity";
export default {
  name: "General",
  metaInfo() {
    return {
      title: "General",
      titleTemplate: "%s - Search - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    Entity
  },
  data() {
    return {
      general: null
    };
  },
  methods: {
    async fetchGeneral() {
      try {
        this.general = null;
        const response = await this.$apollo.query({
          query: SEARCH_GENERAL,
          variables: { value: this.$route.params.searchValue }
        });
        if (!response || !response.data || !response.data.searchGeneral) {
          return;
        }
        this.general = response.data.searchGeneral;
        this.checkNavigate();
      } catch (err) {
        console.error(err);
      }
    },
    checkNavigate() {
      if (
        this.general &&
        this.general.generalResult &&
        this.general.generalResult.length == 1
      ) {
        const entity = this.general.generalResult[0].entity;
        this.$router.push({ name: "entity", params: { id: entity.entityId } });
      }
    }
  },
  watch: {
    "$route.params.searchValue": {
      immediate: true,
      handler() {
        this.fetchGeneral();
      }
    }
  }
};
</script>
